import { LegalPage } from "@/components/LegalPage";

const sections = [
  {
    label: "Not Financial Advice",
    paragraphs: [
      "BENZ THE BRAND and its founder are not licensed financial advisors, accountants, or attorneys. All content in our products, on this website, and on our social media is for informational and educational purposes only and is based solely on personal experience and previous knowledge. Nothing here should be taken as professional financial, legal, or tax advice.",
    ],
  },
  {
    label: "No Guarantees",
    paragraphs: [
      "Results vary. Your financial decisions are your own responsibility. Always consult a qualified professional before making financial decisions.",
    ],
  },
  {
    label: "Personal Experience",
    paragraphs: [
      "Everything shared reflects what worked for the founder personally and is shared in the spirit of inspiration and organization, not professional guidance.",
    ],
  },
];

export default function Disclaimer() {
  return <LegalPage title="Disclaimer" updated="2026-07-06" sections={sections} testId="disclaimer-page" />;
}
